import {
    Box,
    TablePagination,
    Theme
} from "@mui/material";
import { useEffect, useRef } from "react";
import {
    CaretDownIcon,
    PaginationNextIcon,
    PaginationPreviousIcon
} from "../../../../assets/SvgIcons";
//accessbility const variable to handle the focus on the rows per page dropdown
let pendingRowsPerPageFocus = false;
export default function TablePaginationComponent(
    {
        tableDataCount,
        handlePageChange,
        handleRowsPerPageChange,
        rowsPerPageOptions = [10, 20, 30],
        rowsPerPage = 10,
        currentPage = 0
    }: {
        tableDataCount: number,
        handlePageChange: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void,
        handleRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
        rowsPerPageOptions?: number[]
        rowsPerPage?: number;
        currentPage?: number;
    }
): JSX.Element {
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!pendingRowsPerPageFocus) return;
        pendingRowsPerPageFocus = false;
        wrapperRef.current
            ?.querySelector<HTMLElement>('[role="combobox"]')
            ?.focus();
    }, [rowsPerPage]);

    return (
        <Box ref={wrapperRef} sx={{ display: 'contents' }}>
            <TablePagination
                rowsPerPageOptions={rowsPerPageOptions}
                component="div"
                count={tableDataCount}
                rowsPerPage={rowsPerPage}
                page={currentPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={(event) => {
                    pendingRowsPerPageFocus = true;
                    handleRowsPerPageChange(event as React.ChangeEvent<HTMLInputElement>);
                }}
                slotProps={{
                    select: {
                        IconComponent: CaretDownIcon,
                        SelectDisplayProps: { 'aria-label': 'Rows per page' }
                    }
                }}
                // slots={{
                //     actions: {
                //         nextButtonIcon: PaginationNextIcon,
                //         previousButtonIcon: PaginationPreviousIcon
                //     }
                // }}
                sx={(theme: Theme) => ({
                    "& .MuiTablePagination-toolbar": {
                        "& .MuiTablePagination-selectLabel": {
                            ...theme.typography.subtitle_400,
                            color: theme.palette.text.primary,
                        },
                        "& .MuiTablePagination-displayedRows": {
                            ...theme.typography.subtitle_400,
                            color: theme.palette.text.primary,
                            marginBottom: "13px"
                        },
                        "& .MuiTablePagination-input": {
                            "& .MuiTablePagination-select": {
                                paddingTop: "10px",
                                ...theme.typography.subtitle_400,
                                color: theme.palette.text.primary
                            },
                            "& .MuiTablePagination-selectIcon": {
                                color: theme.palette.text.primary
                            }
                        },
                        "& .MuiTablePagination-input.Mui-focused": {
                            outline: `2px solid ${theme.palette.primary.main}`,
                            outlineOffset: "2px",
                            borderRadius: "4px",
                            backgroundColor: "transparent"
                        },
                        '& .MuiSvgIcon-root': {
                        color: 'theme.palette.customColors.infoCardTitle',
                    },
                    '& .MuiSelect-icon': {
                      color: theme.palette.customColors.infoCardTitle,
                    },
                    '& svg': {
                      color: theme.palette.customColors.infoCardTitle, 
                    },

                
                    }
                })}
            />
        </Box>
    )
}